export default __webpack_public_path__ + "static/media/Julian_crop.bc99cb28.jpg";